<script lang="ts">
    import { _ } from 'svelte-i18n';
    import IconAddSimple from '../../Icons/IconAddSimple.svelte';

    export let addWidget: () => void = () => {};
</script>

<div
    class="ui-widget-content"
    style="cursor: pointer"
    title={$_('Dodaj widget')}
    on:click={() => {
        addWidget();
    }}
>
    <div
        class="data-summary"
        style="max-width: 480px; min-width: 200px; width: 100%; display: flex; justify-content: space-evenly; align-items: center; padding: 10px 0; margin: 10px 0; align-items: center; min-height: 200px;"
    >
        <IconAddSimple scale={2.5} />
    </div>
</div>
